// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"437aaa9c","882":"621a5e9c","900":"029fbd64","941":"98e40bee"}[chunkId] + ".chunk.js";
};